import React from 'react';
import { Link } from 'react-router-dom';
import { Shield, ArrowLeft } from 'lucide-react';

const PrivacyPolicyPage = () => {
  return (
    <div data-testid="privacy-policy-page" className="min-h-screen bg-[#FAFAF8]">
      {/* Header */}
      <section className="bg-white py-12 border-b border-slate-100">
        <div className="container mx-auto px-4 md:px-6 lg:px-8 max-w-4xl">
          <Link to="/" className="inline-flex items-center text-[#4CAF50] hover:text-[#43A047] mb-6">
            <ArrowLeft className="w-5 h-5 mr-2" />
            Grįžti į pradžią
          </Link>
          <div className="flex items-center space-x-4">
            <div className="w-14 h-14 bg-[#E8F5E9] rounded-2xl flex items-center justify-center">
              <Shield className="w-8 h-8 text-[#4CAF50]" />
            </div>
            <div>
              <h1 className="text-3xl md:text-4xl font-['Poppins'] font-bold text-[#2D3748]">
                Privatumo politika
              </h1>
              <p className="text-[#718096]">Paskutinis atnaujinimas: 2025 m. sausio mėn.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Content */}
      <section className="py-12">
        <div className="container mx-auto px-4 md:px-6 lg:px-8 max-w-4xl">
          <div className="bg-white rounded-3xl p-8 md:p-12 border border-slate-100 prose prose-slate max-w-none">
            
            <h2 className="text-2xl font-['Poppins'] font-semibold text-[#2D3748] mt-0">1. Bendrosios nuostatos</h2>
            <p className="text-[#718096] leading-relaxed">
              Ši privatumo politika nustato, kaip TavoEmocijos (toliau – „mes", „mūsų" arba „Svetainė") 
              renka, naudoja ir saugo jūsų asmeninę informaciją, kai naudojatės mūsų svetaine 
              ir paslaugomis.
            </p>
            <p className="text-[#718096] leading-relaxed">
              Mes gerbiame jūsų privatumą ir įsipareigojame saugoti jūsų asmens duomenis pagal 
              Bendrąjį duomenų apsaugos reglamentą (BDAR) ir Lietuvos Respublikos teisės aktus.
            </p>

            <h2 className="text-2xl font-['Poppins'] font-semibold text-[#2D3748]">2. Kokius duomenis renkame?</h2>
            <p className="text-[#718096] leading-relaxed">Mes galime rinkti ir apdoroti šiuos duomenis:</p>
            <ul className="text-[#718096] space-y-2">
              <li><strong>Kontaktiniai duomenys:</strong> vardas, pavardė, el. pašto adresas, telefono numeris</li>
              <li><strong>Užsakymų duomenys:</strong> pirkimo istorija, mokėjimo informacija (saugoma mokėjimo paslaugų teikėjo)</li>
              <li><strong>Komunikacijos duomenys:</strong> jūsų užklausos, atsiliepimai, susirašinėjimo istorija</li>
              <li><strong>Techniniai duomenys:</strong> IP adresas, naršyklės tipas, apsilankymo laikas</li>
              <li><strong>Slapukų duomenys:</strong> informacija, surinkta per slapukus (žr. Slapukų politiką)</li>
            </ul>

            <h2 className="text-2xl font-['Poppins'] font-semibold text-[#2D3748]">3. Kaip naudojame jūsų duomenis?</h2>
            <p className="text-[#718096] leading-relaxed">Jūsų duomenis naudojame šiais tikslais:</p>
            <ul className="text-[#718096] space-y-2">
              <li>Paslaugų teikimui ir užsakymų vykdymui</li>
              <li>Komunikacijai su jumis (atsakyti į užklausas, siųsti patvirtinimus)</li>
              <li>Mokėjimų apdorojimui</li>
              <li>Skaitmeninių produktų pristatymui</li>
              <li>Naujienlaiškių siuntimui (tik su jūsų sutikimu)</li>
              <li>Svetainės tobulinimui ir analizei</li>
              <li>Teisinių įsipareigojimų vykdymui</li>
            </ul>

            <h2 className="text-2xl font-['Poppins'] font-semibold text-[#2D3748]">4. Teisinis pagrindas</h2>
            <p className="text-[#718096] leading-relaxed">Jūsų duomenis tvarkome remiantis:</p>
            <ul className="text-[#718096] space-y-2">
              <li><strong>Sutartimi:</strong> kai būtina įvykdyti sutartį su jumis (pvz., užsakymas)</li>
              <li><strong>Sutikimu:</strong> kai davėte sutikimą (pvz., naujienlaiškis)</li>
              <li><strong>Teisėtu interesu:</strong> verslo veiklai vykdyti, svetainei tobulinti</li>
              <li><strong>Teisine prievole:</strong> kai privalome pagal įstatymus</li>
            </ul>

            <h2 className="text-2xl font-['Poppins'] font-semibold text-[#2D3748]">5. Duomenų saugojimas</h2>
            <p className="text-[#718096] leading-relaxed">
              Jūsų duomenis saugome tik tiek, kiek būtina tikslams pasiekti:
            </p>
            <ul className="text-[#718096] space-y-2">
              <li>Užsakymų duomenys – 10 metų (pagal buhalterinės apskaitos reikalavimus)</li>
              <li>Kontaktų formos duomenys – 2 metai</li>
              <li>Naujienlaiškio prenumerata – kol atsisakysite</li>
              <li>Slapukų duomenys – pagal slapukų galiojimo laiką</li>
            </ul>

            <h2 className="text-2xl font-['Poppins'] font-semibold text-[#2D3748]">6. Duomenų perdavimas</h2>
            <p className="text-[#718096] leading-relaxed">
              Jūsų duomenis galime perduoti:
            </p>
            <ul className="text-[#718096] space-y-2">
              <li><strong>Mokėjimų tvarkytojams:</strong> Paysera (mokėjimų apdorojimui)</li>
              <li><strong>El. pašto paslaugų teikėjams:</strong> naujienlaiškių siuntimui</li>
              <li><strong>Teisinėms institucijoms:</strong> kai reikalauja įstatymai</li>
            </ul>
            <p className="text-[#718096] leading-relaxed">
              Nepardavinėjame ir nenuomojame jūsų duomenų trečiosioms šalims rinkodaros tikslais.
            </p>

            <h2 className="text-2xl font-['Poppins'] font-semibold text-[#2D3748]">7. Jūsų teisės</h2>
            <p className="text-[#718096] leading-relaxed">Pagal BDAR turite šias teises:</p>
            <ul className="text-[#718096] space-y-2">
              <li><strong>Teisė susipažinti:</strong> gauti informaciją apie tvarkomus duomenis</li>
              <li><strong>Teisė ištaisyti:</strong> prašyti ištaisyti netikslius duomenis</li>
              <li><strong>Teisė ištrinti:</strong> prašyti ištrinti duomenis („teisė būti pamirštam")</li>
              <li><strong>Teisė apriboti:</strong> prašyti apriboti duomenų tvarkymą</li>
              <li><strong>Teisė nesutikti:</strong> nesutikti su duomenų tvarkymu</li>
              <li><strong>Teisė į perkeliamumą:</strong> gauti duomenis struktūrizuotu formatu</li>
              <li><strong>Teisė atšaukti sutikimą:</strong> bet kada atšaukti duotą sutikimą</li>
            </ul>
            <p className="text-[#718096] leading-relaxed">
              Norėdami pasinaudoti šiomis teisėmis, susisiekite el. paštu: info@tavoemocijos.lt
            </p>

            <h2 className="text-2xl font-['Poppins'] font-semibold text-[#2D3748]">8. Duomenų saugumas</h2>
            <p className="text-[#718096] leading-relaxed">
              Naudojame technines ir organizacines priemones jūsų duomenims apsaugoti:
            </p>
            <ul className="text-[#718096] space-y-2">
              <li>SSL šifravimas duomenų perdavimui</li>
              <li>Saugūs serveriai</li>
              <li>Prieigos kontrolė</li>
              <li>Reguliarios saugumo patikros</li>
            </ul>

            <h2 className="text-2xl font-['Poppins'] font-semibold text-[#2D3748]">9. Skundų teikimas</h2>
            <p className="text-[#718096] leading-relaxed">
              Jei manote, kad jūsų teisės pažeistos, turite teisę pateikti skundą 
              Valstybinei duomenų apsaugos inspekcijai (VDAI): 
              <a href="https://vdai.lrv.lt" className="text-[#4CAF50] hover:underline ml-1" target="_blank" rel="noopener noreferrer">
                vdai.lrv.lt
              </a>
            </p>

            <h2 className="text-2xl font-['Poppins'] font-semibold text-[#2D3748]">10. Kontaktai</h2>
            <p className="text-[#718096] leading-relaxed">
              Dėl privatumo klausimų kreipkitės:
            </p>
            <ul className="text-[#718096] space-y-2">
              <li><strong>El. paštas:</strong> info@tavoemocijos.lt</li>
              <li><strong>Adresas:</strong> Vilnius, Lietuva</li>
            </ul>

            <h2 className="text-2xl font-['Poppins'] font-semibold text-[#2D3748]">11. Pakeitimai</h2>
            <p className="text-[#718096] leading-relaxed">
              Ši privatumo politika gali būti atnaujinama. Apie esminius pakeitimus 
              informuosime svetainėje arba el. paštu.
            </p>

          </div>
        </div>
      </section>
    </div>
  );
};

export default PrivacyPolicyPage;
